"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = require("./src/action");
exports.Action = action_1.default;
var event_1 = require("./src/event");
exports.Event = event_1.default;
var result_1 = require("./src/result");
exports.Result = result_1.default;
var builder_1 = require("./src/result/builder");
exports.data = builder_1.data;
exports.eventTimeout = builder_1.eventTimeout;
exports.internalEvent = builder_1.internalEvent;
exports.keepState = builder_1.keepState;
exports.nextEvent = builder_1.nextEvent;
exports.nextState = builder_1.nextState;
exports.repeatState = builder_1.repeatState;
exports.reply = builder_1.reply;
exports.stateTimeout = builder_1.stateTimeout;
var StateMachine_1 = require("./src/StateMachine");
exports.StateMachine = StateMachine_1.StateMachine;
// @ts-ignore
if (typeof (window) !== "undefined") {
}
//# sourceMappingURL=index.js.map